import {styled} from '@esgi/ui/theme';
import {Box, FlexBox} from '@esgi/ui/layout';
import {RadioGroup} from '@esgi/ui/controls';

export const Wrapper = styled(Box, {
	padding: '8px',
	border: '1px solid $neutral92',
	backgroundColor: '$neutral99',
	borderRadius: '8px',
	marginTop: '8px',
});

export const Link = styled('a', {
	lineHeight: 0,
});

export const RadioboxRoot = styled(RadioGroup.Root, {
	width: '100%',

	'& svg': {
		width: '20px',
		height: '20px',
	},
});

export const RadioboxGroup = RadioGroup.Content;

export const RadioboxGroupItem = styled(FlexBox, {
	justifyContent: 'space-between',
	alignItems: 'center',
});

export const Radiobox = styled(RadioGroup.Item, {
	display: 'inline-flex',

	'& + label': {
		marginBottom: 0,
	},
});
